export default "__VITE_ASSET__6971ce00__"